import React, { createContext, useContext, useEffect, useState } from "react";
import { isKarkhanaSupervisor } from "../helpers/karkhanaEnabled";
import { connect } from "react-redux";
import { getApplication } from "../Store/application/actions";
import { getUsersPrpfileLogo } from "../Store/users/actions";

export type StudioOrgBrand = {
  logo: string;
  name: string;
};

const StudioOrgBrandContext = createContext<StudioOrgBrand>({
  logo: "",
  name: "",
});

export const useStudioOrgBrand = (): StudioOrgBrand =>
  useContext(StudioOrgBrandContext);

const readStudioOrgBrand = (): StudioOrgBrand => {
  try {
    const auth = JSON.parse(localStorage.getItem("authUser") || "null");
    if (auth?.users?.role === "SUPER_ADMIN") {
      return { logo: "", name: "HastKala" };
    }
    const profile = JSON.parse(localStorage.getItem("GetUserRes") || "null");
    const org = auth?.users?.organizationResponse || {};
    const details = profile?.organizationDetails?.[0] || {};
    return {
      logo: details?.logo || org?.logo || "",
      name: details?.name || org?.name || "",
    };
  } catch {
    return { logo: "", name: "" };
  }
};

type ProviderProps = {
  children: React.ReactNode;
  getUsersPrpfileLogo: (filters: any, callback: any) => void;
  getApplication: (callback: any) => void;
};

const StudioOrgBrandProviderInner: React.FC<ProviderProps> = (props) => {
  const [brand, setBrand] = useState<StudioOrgBrand>(readStudioOrgBrand);

  useEffect(() => {
    let auth: any = {};
    try {
      auth = JSON.parse(localStorage.getItem("authUser") || "null") || {};
    } catch {
      auth = {};
    }
    const userId = auth?.users?._id;
    if (!userId) {
      return;
    }
    if (auth?.users?.role === "SUPER_ADMIN") {
      props.getApplication((appRes: any) => {
        setBrand({
          logo: appRes?.data?.docs?.[0]?.logo || "",
          name: "HastKala",
        });
      });
      return;
    }
    if (isKarkhanaSupervisor(auth?.users?.role)) {
      // Supervisors can't read user profiles; the studio name already comes from the login token.
      return;
    }
    props.getUsersPrpfileLogo({ userId }, (res: any) => {
      if (!res?.data?.docs?.[0]) {
        // A failed lookup must not leave "undefined" behind: every page reads this value.
        return;
      }
      localStorage.setItem("GetUserRes", JSON.stringify(res.data.docs[0]));
      const details = res?.data?.docs[0]?.organizationDetails?.[0];
      const org = auth?.users?.organizationResponse || {};
      const name = details?.name || org?.name || "";
      if (details?.logo?.length) {
        setBrand({ logo: details.logo, name });
        return;
      }
      props.getApplication((appRes: any) => {
        setBrand({
          logo: appRes?.data?.docs?.[0]?.logo || org?.logo || "",
          name,
        });
      });
    });
  }, []);

  return (
    <StudioOrgBrandContext.Provider value={brand}>
      {props.children}
    </StudioOrgBrandContext.Provider>
  );
};

export const StudioOrgBrandProvider = connect(null, {
  getUsersPrpfileLogo,
  getApplication,
})(StudioOrgBrandProviderInner);
